// Custom: Enhances Shopify email signup post-submit feedback for WCAG 2.2 form status notification.
// Custom: Runs only after Shopify renders a success message; it does not intercept or alter form submission.
(() => {
  const SUCCESS_MESSAGE_SELECTOR = '[data-custom-email-signup-status="success"]';
  const ANNOUNCEMENT_DELAY = 150;
  const SCROLL_OFFSET = 120;
  const RESTORE_SCROLL_BEHAVIOR_DELAY = 500;
  const REMOVE_ANNOUNCEMENT_DELAY = 5000;

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  };

  const getMessageText = (element) => element.textContent.replace(/\s+/g, ' ').trim();

  const announce = (message) => {
    // Custom: Dynamic live-region update makes post-submit status available to screen readers after a full page reload.
    const liveRegion = document.createElement('div');
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');

    document.body.append(liveRegion);

    window.requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });

    window.setTimeout(() => {
      liveRegion.remove();
    }, REMOVE_ANNOUNCEMENT_DELAY);
  };

  const focusWithoutScroll = (element) => {
    try {
      element.focus({ preventScroll: true });
    } catch (_error) {
      element.focus();
    }
  };

  const jumpToMessage = (messageElement) => {
    const root = document.documentElement;
    const previousScrollBehavior = root.style.scrollBehavior;
    const messageTop = messageElement.getBoundingClientRect().top + window.scrollY;

    // Custom: Override Horizon's global smooth scrolling for this post-submit jump to avoid motion/jank.
    root.style.scrollBehavior = 'auto';
    window.scrollTo({
      top: Math.max(0, messageTop - SCROLL_OFFSET),
      behavior: 'auto',
    });

    window.requestAnimationFrame(() => {
      focusWithoutScroll(messageElement);

      window.setTimeout(() => {
        announce(getMessageText(messageElement));
      }, ANNOUNCEMENT_DELAY);

      window.setTimeout(() => {
        root.style.scrollBehavior = previousScrollBehavior;
      }, RESTORE_SCROLL_BEHAVIOR_DELAY);
    });
  };

  onReady(() => {
    const successMessage = document.querySelector(SUCCESS_MESSAGE_SELECTOR);

    if (!(successMessage instanceof HTMLElement)) return;
    if (successMessage.dataset.customEmailSignupAnnounced === 'true') return;

    const messageText = getMessageText(successMessage);
    if (!messageText) return;

    successMessage.dataset.customEmailSignupAnnounced = 'true';
    jumpToMessage(successMessage);
  });
})();